import { handleIsLoadMoreCars } from '../../features/cars-list/model'
import { removeDealers } from '../../features/filter/model'

export const setCarsNextDealer = (showCarsNextDealer: boolean, value: string) => {
  const storedDealerId = localStorage.getItem('@kodix/one/dealer/id')?.replace(/"/g, '') || ''

  if (storedDealerId === value && !sessionStorage.getItem('isReloaded')) {
    sessionStorage.setItem('isReloaded', 'true')
  }

  handleIsLoadMoreCars(false)

  if (showCarsNextDealer) {
    removeDealers()
  }
}
